import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-transmission-badge',
  templateUrl: './transmission-badge.component.html',
  styleUrls: ['./transmission-badge.component.scss'],
})
export class TransmissionBadgeComponent {
  @Input() isTransmission = false;
}
